import { env } from '@/environment';
import { simpleFetchWithAuth, type TFetchOptions } from '@/features/api/simpleFetch';
import { type TTravelInsuranceResponse } from '@/infra/types/summary';

export const fetchTravelInsurance = (options: TFetchOptions) =>
  simpleFetchWithAuth<TTravelInsuranceResponse>(`${env.REST_BFF_URL}/travelInsurance`, options);
